import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Layout from "layouts/LayoutMasterDetail";

import { StoreContext } from "shared/context/store-context";

import ContractItem from "./managed-contract/ContractItem";
import ManagedContract from "./managed-contract/ManagedContract";

const ContractsList = () => {
  const { t } = useTranslation();
  const itemType = "contract";
  const listName = "main_contracts";

  const {
    contracts,
    educationYearsOptions,
    receipts,
    selectedEducationYearId,
    InsertContract,
    UpdateContract,
    DeleteContract,
  } = useContext(StoreContext);

  const [pageItems, setPageItems] = useState(contracts.filter((item) => item.year === selectedEducationYearId));

  useEffect(() => {
    setPageItems(contracts.filter((item) => item.year === selectedEducationYearId));
  }, [contracts, selectedEducationYearId]);

  const listColumns = [
    {
      field: "school",
      headerName: t("school"),
      width: 300,
      valueGetter: (params) => params?.row?.school?.name || "-",
    },
    {
      field: "year",
      headerName: t("year"),
      width: 150,
      valueGetter: (params) =>
        educationYearsOptions.find((item) => item?.value?.toString() === params.row?.year?.toString())?.label || "",
    },
    { field: "date", headerName: t("date"), width: 150 },
    { field: "payerName", headerName: t("payerName"), width: 300 },
    {
      field: "student",
      headerName: t("student.title"),
      width: 300,
      valueGetter: (params) => {
        try {
          const studentName = params?.row?.student?.name?.toString() || "";
          const isStudentInDifferentSchool = !params.row.isStudentInYourSchool;
          return studentName + (isStudentInDifferentSchool ? " (Şu anda başka okulda)" : "");
        } catch {
          return "";
        }
      },
    },
    { field: "finalAmount", headerName: t("finalAmount"), width: 125 },

    {
      field: "totalPayed",
      headerName: t("paid"),
      width: 125,
      valueGetter: (params) => {
        try {
          const contractId = params.row.id.toString();
          const allreceipts = receipts.filter((item) => item.contract.id.toString() === contractId);

          let totalPayed = 0;
          allreceipts.forEach((item) => {
            totalPayed += item.amount;
          });

          return totalPayed;
        } catch (e) {
          return "";
        }
      },
    },

    {
      field: "totalBorc",
      headerName: t("remainingBalance"),
      width: 125,
      valueGetter: (params) => {
        try {
          const contractId = params.row.id.toString();

          const allreceipts = receipts.filter((item) => item.contract.id.toString() === contractId);

          let totalPayed = 0;
          allreceipts.forEach((item) => {
            totalPayed += item.amount;
          });

          return parseFloat(params.row.finalAmount) - totalPayed;
        } catch (e) {
          return "";
        }
      },
    },

    {
      field: "receiptCount",
      headerName: t("receiptCount"),
      width: 125,
      valueGetter: (params) => {
        try {
          const contractId = params.row.id.toString();
          return receipts.filter((item) => item.contract.id.toString() === contractId).length;
        } catch (e) {
          return 0;
        }
      },
    },

    {
      field: "isStudentInYourSchool",
      headerName: t("isStudentInYourSchool"),
      width: 250,
      valueGetter: (params) => {
        return params.row.isStudentInYourSchool ? t("yes") : t("no");
      },
    },

    {
      field: "userApproved",
      headerName: t("userApproved"),
      width: 75,
      valueGetter: (params) => (params?.row?.userApproved === true ? "Evet" : "Hayır"),
    },

    {
      field: "includesStudy",
      headerName: t("contract.includesStudy"),
      width: 100,
      valueGetter: (params) => (params?.row?.includesStudy === true ? t("yes") : t("no")),
    },

    {
      field: "studyAmount",
      headerName: t("contract.studyAmount"),
      width: 125,
      valueGetter: (params) => {
        if (params?.row?.includesStudy === true && params?.row?.studyAmount) {
          return params.row.studyAmount;
        }
        return "-";
      },
    },

    { field: "payerIdentity", headerName: t("identityNumber"), width: 150, hide: true },
    { field: "payerMail", headerName: t("email"), width: 150, hide: true },
    { field: "payerAddress", headerName: t("address"), width: 450, hide: true },
    {
      field: "isCompanyReceipt",
      headerName: t("isCompanyInvoice"),
      width: 150,
      valueGetter: (params) => (params?.row?.isCompanyReceipt === true ? t("yes") : t("no")),
      hide: true,
    },

    { field: "companyTitle", headerName: t("companyName"), width: 150, hide: true },
    { field: "taxNo", headerName: t("taxId"), width: 125, hide: true },
    { field: "taxOffice", headerName: t("taxOffice"), width: 150, hide: true },
    //{ field: "notes", headerName: "Notlar", width: 150 },
  ];

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      showSelectedYear={true}
      isAlwaysFullScreen={true}
      // hideCreateNewItem={false}

      SelectedItemComponent={ManagedContract}
      NewItemComponent={ContractItem}
      DeleteItem={DeleteContract}
      InsertItem={InsertContract}
      UpdateItem={UpdateContract}
      hideCreateNewItemWhenSelected={true}
    />
  );
};

export default ContractsList;
